var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('dx-popup',_vm._g(_vm._b({on:{"update:visible":_vm.onUpdateVisible}},'dx-popup',_vm.internalProps,false),_vm.$listeners),[_vm._t("default"),_vm._t("toolbar-items")],2)}
var staticRenderFns = []

export { render, staticRenderFns }